/**
 * @generated SignedSource<<14cec96bde0ddc9e5c65496e6d28e6cc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WooviPayPlugin_charge$data = {
  readonly id: string;
  readonly paymentMethods: ReadonlyArray<{
    readonly method?: string;
  } | null | undefined> | null | undefined;
  readonly status: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"Payment_charge">;
  readonly " $fragmentType": "WooviPayPlugin_charge";
};
export type WooviPayPlugin_charge$key = {
  readonly " $data"?: WooviPayPlugin_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"WooviPayPlugin_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WooviPayPlugin_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "paymentMethods",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "method",
              "storageKey": null
            }
          ],
          "type": "PaymentMethodPix",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Payment_charge"
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "f3ce25614bc5d0f651e72c4c87a89c9c";

export default node;
